import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MaintenanceSchedule } from '@app/shared/models/maintenance';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService extends ApiService {
  maintenanceUri = 'api/maintenance';

  constructor(public http: HttpClient) {
    super(http);
  }

  public getMaintenanceSchedule(featureCode: string): Observable<MaintenanceSchedule> {
    const params = new HttpParams().set('featureCode', featureCode).set('tenant', environment.tenant);
    return this.http.get<MaintenanceSchedule>(this.endpoint(this.maintenanceUri), { params });
  }
}
